/**
 * @format
 */

export const webResources = {};
